<div fxLayout="row" fxLayoutAlign="space-between center" class="wh100">
  <div fxFlexAlign="stretch" fxFlex>
    <ng-content />
  </div>
</div>
